import React, {
  Children, cloneElement, useCallback, useEffect, useState
} from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line boundaries/element-types
import {
  useGetAppUserResourceIdQuery,
  usePatchAppUserResourceMutation
} from "../appUsersResource/redux/appUsersResource.api";
// eslint-disable-next-line boundaries/element-types
import {
  useGetUserResourceIdQuery,
  usePutUserResourceMutation
} from "../usersResource/redux/usersResource.api";
import {
  usePatchCustomAugmentationAttrsMutation,
  usePatchCustomAugmentationsMutation,
} from "../appUsersResource/redux/customAugmentation.api";
import { findTimeZoneAttr } from "../../../shared/utils/timezones";

// Компонента Бизнес уровня которая является связующим звеном между фронтом и бизнесом
// Компонента возвращает Children с новыми пропсами из бизнес уровня
function AccountMainBll({ children, idUser, login }) {
  const [data, setData] = useState();

  const {
    data: dataAppUserResourceId,
  } = useGetAppUserResourceIdQuery({
    id: idUser,
  });

  const { data: dataUserResourceId } = useGetUserResourceIdQuery({
    id: login,
  });

  const [patchAppUserResource] = usePatchAppUserResourceMutation();
  const [putUserResource] = usePutUserResourceMutation();
  const [patchCustomAugmentationAttrs] = usePatchCustomAugmentationAttrsMutation();
  const [patchCustomAugmentations] = usePatchCustomAugmentationsMutation();

  const patchCustomAugmentation = useCallback(
    ({ id, body }) => patchCustomAugmentations({
      id,
      body,
    }),
    []
  );

  const patchAppUserResourceParams = useCallback(
    ({ id, body }) => patchAppUserResource({
      id,
      body,
    }),
    []
  );

  useEffect(() => {
    setData({
      dataAppUserResourceId,
      dataUserResourceId,
    });
  }, [dataAppUserResourceId, dataUserResourceId]);

  const putUserResourceParams = useCallback(
    ({ id, body }) => putUserResource({
      id,
      body,
    }),
    []
  );

  const saveTimeZone = useCallback(
    (timeZone) => {
      const customAugmentationId = dataAppUserResourceId?.data?.customAugmentation?.customAugId;
      const timeZoneAttr = findTimeZoneAttr(dataAppUserResourceId?.data?.customAugmentation?.attrs);
      if (customAugmentationId && timeZoneAttr?.customAugAttrId) {
        // TODO Починить добавление временного смещения через augmentation или иначе
        patchCustomAugmentationAttrs({
          id: timeZoneAttr.customAugAttrId,
          body: {
            ...timeZoneAttr,
            value: timeZone,
          },
        }).then(() => {
          patchCustomAugmentation({
            id: customAugmentationId,
            body: {
              ...dataAppUserResourceId.data.customAugmentation,
              attrs: [
                ...dataAppUserResourceId.data.customAugmentation.attrs,
                {
                  ...timeZoneAttr,
                  value: timeZone,
                }
              ]
            }
          });
        });
      }
    },
    [dataAppUserResourceId]
  );

  const props = {
    data,
    patchAppUserResourceParams,
    putUserResourceParams,
    saveTimeZone,
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{Children.toArray(children).map((child) => cloneElement(child, props))}</>
  );
}

AccountMainBll.propTypes = {
  idUser: PropTypes.number,
  login: PropTypes.string,
  children: PropTypes.element.isRequired,
};

AccountMainBll.defaultProps = {
  idUser: null,
  login: null,
};

export default AccountMainBll;
